import React from 'react'

import { TbLogout } from 'react-icons/tb'

import './styles.scss'
import { decryptData } from '../../../helpers/encrypt/crypto-encrypt'

export const UserProfile = ({ handleLogout }) => {
    let user_decrypt = decryptData(sessionStorage.getItem('rqewseu'))
    let role_decrypt = decryptData(sessionStorage.getItem('eqlwoer'))

    const userDetails = {
        userName: user_decrypt?.userName || '',
        userEmail: user_decrypt?.usermail || '',
        userRole: role_decrypt?.role || '',
    }

    return (
        <div className="profile-drop-contents">
            <div className="user-details">
                <div className="user-name">{userDetails?.userName}</div>
                <div className="user-email">{userDetails?.userEmail}</div>
            </div>
            <div className="user-action">
                <div className="user-action-buttons logout-button" onClick={() => handleLogout()}>
                    <div className="button-icon">
                        <TbLogout />
                    </div>
                    <div className="button-text">Logout</div>
                </div>
            </div>
        </div>
    )
}
